<!--
제한 수기조작 통합 컴포넌트
- 배송등록 제한/해지, 출고 제한/해지 4가지 동작을 하나로 통합
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-large">

            <div class="uk-modal-header">
                <h4>
                    <i class="material-icons">{{ actionIcon }}</i>
                    {{ title }}
                </h4>
            </div>

            <div class="uk-modal-body">
                <!-- 회원사 정보 -->
                <table class="info-table small uk-width-1-1" style="margin-bottom: 1rem">
                    <colgroup>
                        <col style="width: 5rem">
                        <col>
                    </colgroup>
                    <tr>
                        <th>회원사</th>
                        <td>{{ user.nick }}</td>
                    </tr>
                    <tr>
                        <th>이메일</th>
                        <td>{{ user.email }}</td>
                    </tr>
                    <tr>
                        <th>상호</th>
                        <td>{{ company.name }}</td>
                    </tr>
                </table>

                <!-- 안내 메시지 -->
                <div :style="messageBoxStyle">
                    <div style="margin-bottom: 0.5rem; font-weight: 600">
                        <i class="material-icons uk-text-middle" style="font-size: 1.125rem">{{ messageIcon }}</i>
                        {{ messageTitle }}
                    </div>
                    <div v-for="line in messageLines" :key="line">{{ line }}</div>
                </div>
            </div>

            <div class="uk-modal-footer uk-text-right">
                <button type="button"
                        class="uk-button uk-button-default uk-modal-close">
                    <span uk-icon="icon: close"></span> 취소
                </button>
                <button type="button"
                        :class="submitButtonClass"
                        :disabled="submitting"
                        @click="submit">
                    <span uk-icon="icon: check"></span>
                    {{ submitting ? '처리중...' : submitLabel }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    var ACTION_CONFIG = {
        'set-register': {
            title: '배송등록 수기 제한',
            actionIcon: 'lock',
            messageIcon: 'warning',
            messageTitle: '배송등록을 제한합니다.',
            messageLines: [
                '모든 지역의 배송등록을 할 수 없게 됩니다.',
            ],
            messageType: 'danger',
            submitLabel: '제한 실행',
            submitClass: 'uk-button uk-button-danger',
            url: '/company-users/{id}/set-restrict-register',
        },
        'unset-register': {
            title: '배송등록 제한 해지',
            actionIcon: 'lock_open',
            messageIcon: 'check_circle',
            messageTitle: '배송등록 제한을 해지합니다.',
            messageLines: [
                '해당 회원사의 배송등록이 다시 가능해집니다.',
            ],
            messageType: 'success',
            submitLabel: '해지 실행',
            submitClass: 'uk-button uk-button-primary',
            url: '/company-users/{id}/unset-restrict-register',
        },
        'set-shipout': {
            title: '출고 수기 제한',
            actionIcon: 'lock',
            messageIcon: 'warning',
            messageTitle: '출고를 제한합니다.',
            messageLines: [
                '모든 지역의 출고가 불가능합니다.',
                '창고에서 패킹 후 자동으로 출고보류 처리됩니다.',
            ],
            messageType: 'danger',
            submitLabel: '제한 실행',
            submitClass: 'uk-button uk-button-danger',
            url: '/company-users/{id}/set-restrict-shipout',
        },
        'unset-shipout': {
            title: '출고 제한 해지',
            actionIcon: 'lock_open',
            messageIcon: 'check_circle',
            messageTitle: '출고 제한을 해지합니다.',
            messageLines: [
                '해당 회원사의 출고가 다시 가능해집니다.',
                '출고보류 중인 배송은 별도로 출고요청해야 합니다.',
                '(배송조회 > 출고보류중 검색 > 출고요청 일괄 실행)',
            ],
            messageType: 'success',
            submitLabel: '해지 실행',
            submitClass: 'uk-button uk-button-primary',
            url: '/company-users/{id}/unset-restrict-shipout',
        },
    };

    export default {
        props: {
            csrfToken: {
                type: String,
                required: true,
            },
        },
        data: function () {
            return {
                user: {},
                company: {},
                action: null,
                submitting: false,
            };
        },
        computed: {
            config: function () {
                return ACTION_CONFIG[this.action] || {};
            },
            title: function () { return this.config.title || ''; },
            actionIcon: function () { return this.config.actionIcon || 'settings'; },
            messageIcon: function () { return this.config.messageIcon || 'info'; },
            messageTitle: function () { return this.config.messageTitle || ''; },
            messageLines: function () { return this.config.messageLines || []; },
            submitLabel: function () { return this.config.submitLabel || '실행'; },
            submitButtonClass: function () { return this.config.submitClass || 'uk-button uk-button-primary'; },
            messageBoxStyle: function () {
                var type = this.config.messageType || 'info';
                if (type === 'danger') {
                    return 'padding: 1rem; background: #ffebee; border-left: 4px solid #e53935; border-radius: 0 4px 4px 0; color: #c62828';
                }
                return 'padding: 1rem; background: #e8f5e9; border-left: 4px solid #43a047; border-radius: 0 4px 4px 0; color: #2e7d32';
            },
        },
        methods: {
            /**
             * 모달 열기
             * @param {string} action - 'set-register', 'unset-register', 'set-shipout', 'unset-shipout'
             * @param {number} userId
             */
            form: function (action, userId) {
                this.action = action;
                this.submitting = false;

                var self = this;
                var opts = {
                    type: 'get',
                    url: '/company-users/' + userId,
                    contentType: 'application/json',
                    data: {},
                    success: function (response) {
                        self.user = response.user;
                        self.company = response.user.company;
                        UIkit.modal(self.$el).show();
                    },
                };
                $.app.ajax.module.background(opts);
            },

            submit: function () {
                if (this.submitting) return;
                this.submitting = true;

                var url = this.config.url.replace('{id}', this.user.id);
                var self = this;
                var opts = {
                    type: 'patch',
                    url: url,
                    data: { '_token': this.csrfToken },
                    success: function (response) {
                        UIkit.modal.alert(response.msg).then(function () {
                            $.app.refresh();
                        });
                    },
                    complete: function () {
                        self.submitting = false;
                    },
                };
                $.app.ajax.module.default(opts);
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>
